/**
 * Экран «Telegram не отдал данные для входа».
 *
 * Отличается от `<BotDisabledScreen>` принципиально: там проблема с ботом или аккаунтом,
 * тут запрос к нам вообще не уходил. Раньше оба случая выглядели одинаково, и клиент шёл
 * ругаться к партнёру на «сломанный бот», хотя у него самого оборвалась связь или
 * недоступен telegram.org (свой VPN, блокировки).
 */

import { useTranslation } from 'react-i18next';
import { WifiOff } from 'lucide-react';
import { StateScreen } from '@/components/StateScreen';
import { Btn } from '@/components/ui/tiles';

export function TelegramUnavailableScreen({ reason }: { reason: 'no_sdk' | 'no_init_data' }) {
  const { t } = useTranslation();
  const noSdk = reason === 'no_sdk';

  return (
    <StateScreen icon={<WifiOff />} tone="warn" title={noSdk ? t('Tg offline title') : t('Tg no init data title')} description={noSdk ? t('Tg offline description') : t('Tg no init data description')}>
      <Btn className="w-full" onClick={() => window.location.reload()}>
        {t('Tg offline retry')}
      </Btn>
    </StateScreen>
  );
}
